import styled from 'styled-components';

import { Horizontal } from '#src/atoms/layout/flex/index.tsx';
import { tabletAndAbove } from '#src/style/mediaQuery.ts';
import { theme } from '#src/style/theme.tsx';

import minus18Icon from './assets/18.svg';
import franceLogo from './assets/france.webp';

const JOUEURS_INFO_SERVICE_URL = 'https://www.joueurs-info-service.fr';

const Root = styled.a`
  isolation: isolate;
  width: 100%;
  min-height: 10dvh;
  display: flex;
  flex-direction: column;
  text-decoration: none;
  padding: var(--unit) var(--double-unit);
  gap: var(--unit);
  justify-content: space-evenly;
  z-index: ${theme.zIndex.snackbar + 1};
  @media ${tabletAndAbove} {
    padding: var(--double-unit) var(--quadruple-unit);
  }
`;

const Message = styled.p`
  font-weight: 700;
  text-transform: uppercase;
  color: var(--c-white);
  text-align: center;
  font-size: clamp(12px, calc(1.4 * var(--vw)), 18px);
  line-height: 1.4;
  margin: 0;
  @media ${tabletAndAbove} {
    font-size: clamp(14px, calc(1.4 * var(--vw)), 20px);
  }
`;

const GouvernementLogoWrapper = styled.div`
  background: white;
  border-radius: var(--half-unit);
  padding: var(--half-unit) var(--unit);
`;

type Props = {
  className?: string;
};

export const LegalWarningBanner = ({ className }: Props) => {
  return (
    <Root
      className={className}
      href={JOUEURS_INFO_SERVICE_URL}
      target="_blank"
      rel="noopener noreferrer"
    >
      <Message>
        Votre activité de jeu peut être dangereuse : pertes d&apos;argent,
        conflits familiaux, addiction, etc. Retrouvez nos conseils sur
        joueurs-info-service.fr (09 74 75 13 13 - appel non surtaxé)
      </Message>
      <Horizontal center gap={2}>
        <img src={minus18Icon} alt="Interdit aux moins de 18 ans" height={36} />
        <GouvernementLogoWrapper>
          <img
            src={franceLogo}
            alt="Gouvernement Français - Liberté, Égalité, Fraternité"
            height={36}
          />
        </GouvernementLogoWrapper>
      </Horizontal>
    </Root>
  );
};
